<script>
import StarRating from "@/components/reviews/StarRating.vue";

export default {
  name: 'ReviewItem',
  components: {StarRating},
  props: {
    review: {
      type: Object,
      required: true
    }
  },
  computed: {
    getUser () {
      return `${this.review.users.lastname} ${this.review.users.firstname}`
    },
    formatDate () {
      const date = new Date(this.review.publishedAt)
      const options = {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }
      const formatter = new Intl.DateTimeFormat('fr-FR', options);
      let formattedDate = formatter.format(date);
      return formattedDate.replace(", ", " à ");
    }
  }
}
</script>

<template>
  <div class="gap-3 pb-6 sm:flex sm:items-start">
    <div class="shrink-0 space-y-2 sm:w-48 md:w-72">
      <star-rating :note="review.note" />
      <div class="space-y-0.5">
        <p class="text-base font-semibold text-gray-900 dark:text-white">
          {{ getUser }}
        </p>
        <p class="text-sm font-normal text-gray-500 dark:text-gray-400">
          {{ formatDate }}
        </p>
      </div>
    </div>

    <div class="mt-4 min-w-0 flex-1 space-y-4 sm:mt-0">
      <p class="text-base font-normal">
        {{ review.Text }}
      </p>
    </div>
  </div>
</template>